import { Component } from '@angular/core';

@Component({
  templateUrl: 'login.component.html'
})
export class LoginComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/pages/login.component.ts